/**
 * Utility function for merging class names
 * Re-exports from shared package for convenience
 */

export { cn } from "@jesus-central-church/shared";
